import React from 'react';
import '../css/NftMarketDetail.css';

export default function MarketTabBox({
	itemType = 'kind',
	itemName = 'Shiba Inu',
	traitValue = '1',
}) {
	return (
		<div className='item_container'>
			<div className='item_Box'>
				<div className='item_Box_left'>
					<span>{itemType}</span>
					<p>{itemName}</p>
				</div>
				<div className='item_Box_right'>
					<span>{traitValue}% have this trait</span>
				</div>
			</div>
		</div>
	);
}
